// Base API service with common HTTP methods
import axiosInstance from './axios.config';
import { ApiResponse, ApiRequestConfig } from '@types';

class BaseApiService {
  protected async get<T>(url: string, config?: ApiRequestConfig): Promise<ApiResponse<T>> {
    return axiosInstance.get<unknown, ApiResponse<T>>(url, config);
  }

  protected async post<T, D = unknown>(
    url: string,
    data?: D,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<T>> {
    return axiosInstance.post<unknown, ApiResponse<T>, D>(url, data, config);
  }

  protected async put<T, D = unknown>(
    url: string,
    data?: D,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<T>> {
    return axiosInstance.put<unknown, ApiResponse<T>, D>(url, data, config);
  }

  protected async patch<T, D = unknown>(
    url: string,
    data?: D,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<T>> {
    return axiosInstance.patch<unknown, ApiResponse<T>, D>(url, data, config);
  }

  protected async delete<T>(url: string, config?: ApiRequestConfig): Promise<ApiResponse<T>> {
    return axiosInstance.delete<unknown, ApiResponse<T>>(url, config);
  }
}

export default BaseApiService;
